<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="productSalesLetters"
  >
    <div
      v-if="productoCartas.length > 0"
      class="align-items-baseline display-flex-row m-filters-and-actions"
    >
      <form
        autocomplete="off"
        class="align-items-baseline m-form-row"
        name="simple-filters-form"
        @submit.prevent="false"
      >
        <AtomButtonSecondary
          :button-secondary="buttonSecondary.create"
          :disabled="pagination.showLoadingState"
          @showModal="$modal.showModal"
        />
      </form>
    </div>
    <div
      v-if="productoCartas.length > 0"
      class="m-table-primary"
    >
      <table>
        <tr>
          <th class="text-align-left">
            {{ $t('mEditionProductSalesLetters.table.thName') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionProductSalesLetters.table.thWatch') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionProductSalesLetters.table.thEdit') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionProductSalesLetters.table.thPusblished') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionProductSalesLetters.table.thPrimary') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionProductSalesLetters.table.thDelete') }}
          </th>
        </tr>
        <tr
          v-for="carta in productoCartas"
          :key="carta.id"
          class="row-data"
        >
          <td class="text-align-left">
            {{ carta.nombre }}
            <small v-if="carta.externo == 'externo'">
              - {{ $t('mEditionProductSalesLetters.externalSite') }}
            </small>
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.watch"
              :element="carta.externo === 'externo' ? carta.url : `https://${carta.url_preview}`"
              @openTab="openTab"
            />
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              v-if="carta.externo == 'externo'"
              :key="`externalSite-${carta.id}`"
              :button-icon-rounded="buttonIconRounded.editExternalSite"
              :element="{ 'carta': carta, 'productoNombre': element.nombre }"
              @showModal="$modal.showModal"
            />
            <AtomButtonIconRounded
              v-else
              :key="`page-${carta.id}`"
              :button-icon-rounded="buttonIconRounded.editPage"
              :element="carta"
              @createProductoPaginaIdroopActivarEdicion="createProductoPaginaIdroopActivarEdicion"
            />
          </td>
          <td class="text-align-center">
            <AtomTogglePrimary
              v-model="carta.publicada"
              :element-id="carta.id"
              method="updateProductoPaginaIdroopPublicar"
              name="publicada"
              sliderClass="a-toggle-slider-products-primary"
              type="checkbox"
              @updateProductoPaginaIdroopPublicar="updateProductoPaginaIdroopPublicar"
            />
          </td>
          <td class="text-align-center">
            <AtomTogglePrimary
              v-model="carta.primaria"
              :element-id="carta.id"
              method="updateProductoPaginaIdroopPublicarPrimaria"
              name="primaria"
              sliderClass="a-toggle-slider-products-primary"
              type="radio"
              @updateProductoPaginaIdroopPublicarPrimaria="updateProductoPaginaIdroopPublicarPrimaria"
            />
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.delete"
              :element="carta"
              @showModal="$modal.showModal"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary :pagination="pagination"/>
    </div>
    <div
      v-else
    >
      <MoleculeEditionProductSalesLettersCreateExternalSite />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionProductSalesLetters',

  components: {
    MoleculeEditionProductSalesLettersCreateExternalSite: () => import('@/components/molecules/MoleculeEditionProductSalesLettersCreateExternalSite'),
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  props: {
    element: Object,
    elementCategorias: Array
  },

  data () {
    return {
      buttonIconRounded: {
        delete: {
          class: 'a-button-secondary a-button-danger-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: 'MoleculeEditionProductSalesLettersModalDelete',
          icon: 'far fa-trash-alt',
          method: 'showModal',
          tooltip: this.$t('mEditionProductSalesLetters.tooltip.delete'),
          type: 'button'
        },

        editExternalSite: {
          class: 'a-button-secondary a-button-products-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: 'MoleculeEditionProductSalesLettersModalEditExternalSite',
          icon: 'fas fa-pencil-alt',
          method: 'showModal',
          tooltip: this.$t('mEditionProductSalesLetters.tooltip.edit'),
          type: 'button'
        },

        editPage: {
          class: 'a-button-secondary a-button-products-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-pencil-alt',
          method: 'createProductoPaginaIdroopActivarEdicion',
          tooltip: this.$t('mEditionProductSalesLetters.tooltip.edit'),
          type: 'button'
        },

        watch: {
          class: 'a-button-secondary a-button-products-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-envelope-open-text',
          method: 'openTab',
          tooltip: this.$t('mEditionProductSalesLetters.tooltip.watch'),
          type: 'button'
        }
      },

      buttonSecondary: {
        create: {
          class: 'a-button-secondary a-button-products-secondary',
          component: 'MoleculeEditionProductSalesLettersModalCreateExternalSite',
          icon: 'fas fa-plus',
          method: 'showModal',
          text: 'Agregar Carta',
          type: 'button'
        }
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 1,
        totalQuantity: 0
      },

      productoCartas: [],
      showLoadingState: true
    }
  },

  computed: {
    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    updatedData () {
      this.readProductoPaginasIdroop()
    }
  },

  created () {
    this.readProductoPaginasIdroop(true)
  },

  methods: {
    createProductoPaginaIdroopActivarEdicion (carta) {
      this.$services.create('producto', 'createProductoPaginaIdroopActivarEdicion', {}, [carta.id])
        .then(response => {
          window.open(response.data.url, '_blank')
        })
        .catch(error => {
          console.log(error)
          this.$alerts.pushAlert('mEditionProductSalesLetters', 'createProductoPaginaIdroopActivarEdicion', 'error', 'a-alert-danger')
        })
    },

    openTab (url) {
      if (url === 'https://undefined') {
        this.$modal.showModal('MoleculeEditionProductSalesLettersModalUndefined')
      } else {
        window.open(url, '_blank')
      }
    },

    readProductoPaginasIdroop (redirect) {
      this.$services.read('producto', 'readProductoPaginasIdroop', {}, [this.$route.params.id, 0])
        .then(response => {
          console.log(response.data)
          this.productoCartas = response.data
          this.pagination.currentQuantity = this.productoCartas.length
          this.pagination.totalQuantity = this.productoCartas.length
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
        })
    },

    updateProductoPaginaIdroopDesactivar (pagina) {
      this.$services.update('producto', 'updateProductoPaginaIdroopDesactivar', {}, [pagina.id])
        .then(response => {
          console.log(response.data)
          this.$modal.updateData()
          this.$alerts.pushAlert('mEditionProductSalesLetters', 'updateProductoPaginaIdroopDesactivar', 'success')
        })
        .catch(error => {
          console.log(error)
          this.$alerts.pushAlert('mEditionProductSalesLetters', 'updateProductoPaginaIdroopDesactivar', 'error', 'a-alert-danger')
        })
    },

    updateProductoPaginaIdroopPublicar (pagina) {
      if (pagina.state) {
        this.$services.update('producto', 'updateProductoPaginaIdroopPublicar', {}, [pagina.id, 0])
          .then(response => {
            console.log(response.data)
            this.$modal.updateData()
            this.$alerts.pushAlert('mEditionProductSalesLetters', 'updateProductoPaginaIdroopPublicar', 'success')
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionProductSalesLetters', 'updateProductoPaginaIdroopPublicar', 'error', 'a-alert-danger')
          })
      } else {
        this.updateProductoPaginaIdroopDesactivar(pagina)
      }
    },

    updateProductoPaginaIdroopPublicarPrimaria (pagina) {
      this.$services.update('producto', 'updateProductoPaginaIdroopPublicar', {}, [pagina.id, 1])
        .then(response => {
          console.log(response.data)
          this.$modal.updateData()
          this.$alerts.pushAlert('mEditionProductSalesLetters', 'updateProductoPaginaIdroopPublicarPrimaria', response.data.primaria ? 'activationSuccess' : 'deactivationSuccess')
        })
        .catch(error => {
          console.log(error)
          this.$alerts.pushAlert('mEditionProductSalesLetters', 'updateProductoPaginaIdroopPublicarPrimaria', 'error', 'a-alert-danger')
        })
    }
  }
}
</script>
